module.exports = __webpack_public_path__ + "static/logo-a2247c87e672c447a4f0c1a28a977065.svg";